import React from 'react';

// Styles
import {
	ContentWrapperStyled,
	CenterContainerStyled,
} from './OverlayContainer.styled';

import { TitleStyled } from '../../library/Text.styled';

const OverlayContainer = (props) => {
	const { allowInteraction } = props;

	return (
		<ContentWrapperStyled
			onClick={() => {
				allowInteraction();
			}}
		>
			<CenterContainerStyled>
				<TitleStyled>Select to interact with the map</TitleStyled>
			</CenterContainerStyled>
		</ContentWrapperStyled>
	);
};

export default OverlayContainer;
